
const {keys_strings} = require( "./Fun_S_Keys");
const {helper_getDirectionByLangCode_fe} = require(  "../../shareCode/Share_S_Helper");
const request = require('request');
const sgMail = require('../../../node_modules/@sendgrid/mail');

// email_bodyWrapper_fs
export const email_bodyWrapper_fs = (htmlToSend_s, langCode_e) => {
    return `
        <div style="background:#885ead;padding: 8px;">
            <div style="max-width:800px;margin: auto;text-align:center;background: white;padding: 16px;/* margin: 8px; */border-radius: 5px;">
                   
                <img style="cursor: pointer; border-radius: 5px; width: 100%;" src="https://firebasestorage.googleapis.com/v0/b/travelquestdev.appspot.com/o/USERS_DRIVE%2FoCsxl7xJMbdRm6oDSRmuhVlYnSA3%2F1636364328189.jpg?alt=media&amp;token=82f48008-2e4b-4507-a75e-e73312f9f86c" >
            
                <div style="direction:${helper_getDirectionByLangCode_fe(langCode_e)}">
                    ${htmlToSend_s}
                </div>
                
                <hr>
                <table style="width:100%;direction: ltr;">
                    <tr>
                       <td style="text-align: initial;">
                            <div>Dan@TravelAndQuest.com</div>
                            <div>Sderot Tsahal 4, Lod, Israel</div>
                            <div>303035596</div>
                            <a href="TravelQuest.xyz" target="_blank" >TravelQuest.xyz</a>
                       </td>
                       <td style="text-align: end;">
                            <img style="width: 66px; border-radius: 16px;" src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Flogo-full-512x512.png?alt=media&token=17b79dff-5b0e-4548-bdd5-eae3aa6fd8e3" >
                        </td>
                    </tr>
                </table>
            </div>
        </div>`
}

// email_swapVars_f
export const email_swapVars_f = ({text_s, data_if_o = null, data_for_oao= null, data_var_o= null}) => {

    // 1) v-if
    if(data_if_o){

        for(let key in data_if_o){
            text_s = text_s.replace(re_startAndEndWith_s(`<ifdiv v-if=\"${key}\"`, "</ifdiv>"),  (ifDiv_s) => {

                let ifName_s = ""
                ifDiv_s = ifDiv_s.replace(re_startAndEndWith_s("v-if=\"", "\""), (vIf_s) => {
                    ifName_s = vIf_s.substring(6, vIf_s.length -1)
                    return ''
                })

                if(!data_if_o[ifName_s]) {
                    return '<div> </div>'
                }

                return ifDiv_s.replace('ifdiv', 'div')
            })
        }
    }

    // 2) vFor for tr
    if(data_for_oao){
        text_s = text_s.replace(re_startAndEndWith_s("<tr v-for=", "</tr>"),  (row_s) => {
            let forLoopVarName_s = ""

            // get v-for
            row_s.replace(re_startAndEndWith_s("v-for=\"", "\""), (vFor_s) => {
                forLoopVarName_s = vFor_s.substring(7, vFor_s.length -1)
                return vFor_s
            })

            // replace all
            let ans_s = ''
            for(let index_n in data_for_oao[forLoopVarName_s]){
                let td_o = data_for_oao[forLoopVarName_s][index_n]
                let newRow_s = row_s
                for(let key_s in td_o){
                    newRow_s = newRow_s.replace(`{{${key_s}}}`, td_o[key_s])
                }
                ans_s += newRow_s
            }

            return ans_s;
        });
    }

    // 3) other variables
    if(data_var_o){
        for(let key_s in data_var_o){
            if(data_var_o[key_s] == null){
                data_var_o[key_s] = '-'
            }
            text_s = text_s.replace(new RegExp(`{{${key_s}}}`, 'g'), data_var_o[key_s])
        }
    }

    // 4) return ans
    return text_s

}

// email_sendMail_f
export const email_sendMail_f = async (from_s, to_s, subject_s, htmlToSend_s, langCode_e, filesUrls_as) => {

    if (to_s === null) {
        console.log("to_s is null")
        return
    }

    const attachments = []
    if (filesUrls_as) {

        for (let i = 0; i < filesUrls_as.length; i++) {
            const fileUrl_s = filesUrls_as[i]
            const pathArr_as = fileUrl_s.split("/")
            const fileName_s = pathArr_as[pathArr_as.length-1]

            attachments.push({
                filename: fileName_s,
                content: await getFileBase64_fp(fileUrl_s),
                type: "application/pdf",
                disposition: "attachment"
            })
        }
    }

    console.log("email_sendMail_f", `send ${subject_s} email to ${to_s}`)

    sendEmail_f({
        to: to_s,
        from: from_s,
        subject: subject_s,
        html: email_bodyWrapper_fs(htmlToSend_s, langCode_e),
        attachments: attachments
    })

};



// ======= helpers ========

// sendEmail_f
let didSetApiKey = false
const sendEmail_f = (objToSend_o) => {
    if(!didSetApiKey){
        didSetApiKey = true
        sgMail.setApiKey(keys_strings.sendGrid_key);
    }
    sgMail.send(objToSend_o);
}

// re_startAndEndWith_s
const re_startAndEndWith_s = (start_s, end_s ) => {
    return new RegExp(`${start_s}.*?${end_s}`, 'g')
}

// getFileBase64_fp
const getFileBase64_fp = (fileUrl) => {

    return new Promise( (resolve, reject) => {
        request({
            method: 'GET',
            encoding: null,
            uri: fileUrl
        }, (err, resp, data)=>{
            resolve(data.toString('base64'))
        })
    })
}



